export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mascot_cartoon.6221c5b.svg";